// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__sNkU5","red":"Button_red__ZO3rJ","grey":"Button_grey__2XacM"};